// Values come from client/.env.development / .env.production
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
export const WEB_URL = process.env.REACT_APP_WEB_URL || window.location.origin;
